import { Box, Icon, Skeleton, Typography } from '@mui/material'
import React from 'react'

const ACDActionButton = ({ title, status_name, start_date, end_date, nav, onClick, isLoading }) => {
  const CardStyle = () => {
    return {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      bgcolor: 'white.main',
      borderRadius: '4.5px',
      paddingBlock: 2.5,
      pl: 3,
      pr: 5,
      boxShadow: '0px 0px 10px lightgray',
      minHeight: 80,
      // cursor: 'pointer',
    }
  }

  return (
    <Box sx={{ ...CardStyle() }}>
      <Box display="flex" flexDirection="column">
        <Typography textTransform="capitalize" noWrap variant="h4" fontWeight="bold">
          {isLoading ? <Skeleton variant="text" width={300} height={30} /> : title}
        </Typography>

        <Box display="flex" gap={1} alignItems="center">
          {isLoading ? (
            <Skeleton variant="text" width={400} />
          ) : (
            <>
              {status_name === 'Active' ? (
                <Typography color="positive.main" variant="body1">
                  {status_name}
                </Typography>
              ) : (
                <Typography color="light-gray-text.main" variant="body1">
                  {status_name}
                </Typography>
              )}
              <Icon sx={{ fontSize: 7, color: 'light-gray-text.main' }}>circle</Icon>
              <Typography color="light-gray-text.main" variant="body1">
                {start_date} - {end_date}
              </Typography>
            </>
          )}
        </Box>
      </Box>
      {['Scheduled', 'Active'].includes(status_name) && (
        <Box onClick={onClick} color="alternate.main" position="relative">
          {nav}
        </Box>
      )}
    </Box>
  )
}

export default ACDActionButton
